import { useCallback, useState } from 'react';

import {
  ViewportBreakpoint,
  getViewportBreakpoint,
} from './getViewportBreakpoint';
import { useViewportSizeEffect } from './useViewportSizeEffect';

export function useViewportBreakpoint(): ViewportBreakpoint {
  const [viewportBreakpoint, setViewportBreakpoint] =
    useState<ViewportBreakpoint>('md');

  useViewportSizeEffect(
    useCallback(() => {
      const newViewportBreakpont = getViewportBreakpoint();

      if (viewportBreakpoint !== newViewportBreakpont) {
        setViewportBreakpoint(newViewportBreakpont);
      }
    }, [viewportBreakpoint])
  );

  return viewportBreakpoint;
}
